import { TableOutlined } from '@ant-design/icons';
import { Button, Dropdown, Tooltip } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';

interface Props {
  editor: any;
}

export const TableSelector: React.FC<Props> = (props) => {
  const { editor } = props;
  const [open, setOpen] = useState(false);
  const isDark = false;

  const [data, setData] = useState({ columns: 1, rows: 1 });
  const gridSize = 10;

  const handleMouseMove = (event: React.MouseEvent) => {
    const rect = (
      event.currentTarget as HTMLDivElement
    ).getBoundingClientRect();
    setData({
      columns:
        Math.floor((event.clientX - rect.left) / (rect.width / gridSize)) + 1,
      rows:
        Math.floor((event.clientY - rect.top) / (rect.height / gridSize)) + 1,
    });
  };

  const getStyle = (index: number) => {
    const columns = index % gridSize;
    const rows = Math.floor(index / gridSize);

    return columns < data.columns && rows < data.rows
      ? ` ${isDark ? 'tw-bg-[#1f1f1f] tw-border-white' : 'tw-bg-[#ddeafb] tw-border-[#c3d9ff]'}`
      : ` ${isDark ? 'tw-bg-[#1f1f1f] tw-border-[#494949]' : 'tw-bg-[#f8f8f8] tw-border-[#e9e9e9]'}`;
  };

  const createTable = (data: { rows: number; columns: number }) => {
    editor.execute('insertTable', data);
  };

  return (
    <Tooltip title="Table">
      <Dropdown
        open={open}
        trigger={['click']}
        destroyPopupOnHide
        onOpenChange={setOpen}
        arrow={false}
        placement="bottomLeft"
        dropdownRender={() => (
          <div
            className={`tw-p-1 ${isDark ? 'tw-bg-black' : 'tw-bg-white'} tw-shadow-custom tw-rounded-md`}
          >
            <div
              className="tw-w-[150px] tw-h-[150px] tw-p-1 tw-grid tw-grid-cols-10 tw-grid-rows-10 tw-gap-[2px]"
              onMouseMove={handleMouseMove}
              onClick={() => {
                setOpen(false);
                createTable(data);
              }}
            >
              {Array.from({ length: gridSize * gridSize }).map((_, index) => (
                <div
                  key={index}
                  className={`tw-w-full tw-h-full tw-p-1 tw-border ${getStyle(index)}`}
                />
              ))}
            </div>
            <div className="tw-text-center tw-mt-2">{`${data.columns}x${data.rows}`}</div>
          </div>
        )}
      >
        <Button
          type="text"
          icon={<TableOutlined />}
          onClick={() => setOpen(!open)}
        />
      </Dropdown>
    </Tooltip>
  );
};
